export default {
  colors: {
    primary: '#01D185',
    primary_light: 'rgba(20, 179, 92, 0.2)',
    success: '#01D185',
    primary_dark: '#104624',
    header: '#1A1A1A',
    headerGradientEnd: '#323333ff',
    tab: '#1A1A1A',
    attention: '#E83F5B',
    hot_background_opacity: '#E83F5B',
    hot_background_border: '#E83F5B',
    promo_marquee_bg: ['#811F10', '#B12722', '#811F10'],
    shape: '#fff',
    mask: 'rgba(0,0,0, 0.68)',
    mask_station: 'rgba(0,0,0, 0.68)',
    mask_coupon: 'rgba(0,0,0, 0.9)',
    title: '#fff',
    tabSpotlightMenu: '#fff',
    tabSpotlightMenuText: '#FFF',
    text: '#fff',
    text_dark: '#FFF',
    text_fixed: '#767676',
    text_2: '#FFF',
    tabInactive: '#fff',
    border_tab: '#999',
    brbButton: '#173C78',
    border: '#555',
    border_light: '#e0dfdf',
    border2: '#333',
    border3: '#222',
    buttonFeedback: '#333',
    button_click_bg: 'rgba(255,255,255,0.1)',
    image_border: '#222',
    placeholder: '#aaa',
    background: '#222',
    background_secondary: '#222',
    background_black: '#111',
    background_black_2: '#111',
    price_card: '#2A2A2A',
    input_search: '#2A2A2A',
    border_opacity: 'rgba(255,255,255, 0.1)',
    border_dark: '#fff',
    alert: '#333',
    silver: '#C6C6C6',
    gold_gradient: ['#ECB451', '#FCCC61', '#ECB451'],
    gold: '#FFD064',
    silver_gradient: ['#A2A2A2', '#BCBCBC', '#A2A2A2'],
    blue_gradient: ['#158CBE', '#0C6388', '#158CBE'],
    silver_dark: '#9A9A9A',
    silver_text: '#FFFFFF',
    gold_dark: '#E8AE4D',
    gold_text: '#FFFFFF',
    gold_light: '#ffe096',
    blue: '#10AECA',
    blue_main_opacity: '#1B2B2E',
    red: '#FE7879',
    yellow: '#FDBB61',
    pink: '#FB9EC1',
    orange: '#ff9514',
    orange_dark: '#FFF',
    orange_opacity: 'rgba(255, 149, 20, 0.35)',
    purple: '#CDA1FB',
    blue_light: '#92CBF7',
    red_light: '#E1A09A',
    green_light: '#E2F1DA',
    promotion_value_bg: '#2e332c',
    black: '#2A2A2A',
    banner_blue: '#83D9F4',
    banner_blue_shadow: '#39B1DA',
    banner_red: '#F57791',
    blue_opacity: 'rgba(21,140,190, 0.1)',
    banner_red_shadow: '#FA3852',
    banner_purple: '#A5B6FD',
    banner_purple_shadow: '#718BD8',
    banner_green: '#66D977',
    banner_green_shadow: '#54B362',
    clube_gradient: ['#555555', '#222'],
    purple_2_shadow_white: '#F9F2FA',
    purple_2_gradient: ['#ff9514', '#ff8c00', '#FF6B00'],
    purple_2_border: '#ff9514',
    spin_button_backgrund: '#BF3DFF',
    spins_text_background: ['#FBB54F', '#FECF76', '#A35A15'],
    spins_text_border: '#FBB54F',
    spin_button_gradient: ['#c962fc', '#BF3DFF', '#9d09e6'],
    fine_alert_gradient: ['#2f2f2f', '#636363'],
    shimmer_placeholder: ['#555', '#AAA', '#555'],
    loading: '#222',
    buttonTitle: '#222',
    red_gradient: ['#B00000', '#FF3B3B', '#B00000'],


    newCouponScreenRed: '#E78D8D',
    newCuponScreenRedLight: '#3E1C1C',
    newCouponScreenGreen: '#28C28D',
    newCuponScreenGreenLight: '#1D3F33',
    newCuponScreenBackground: '#222222',
    newCuponScreenBackgroundSecondary: '#2D2D2D',


    /* ─── Empréstimo / Loan ─── */
    loan_banner_bg: '#158CBE',
    loan_banner_text: '#FFFFFF',
    loan_banner_text_secondary: 'rgba(255, 255, 255, 0.85)',
    loan_banner_overlay: 'rgba(255, 255, 255, 0.2)',
    loan_action_text: '#4FB8E0',
    loan_otp_icon_bg: 'rgba(21, 140, 190, 0.2)',
    loan_otp_icon: '#4FB8E0',
    alert_red_bg: '#2D1515',
    alert_red_border: '#7F1D1D',
    alert_red_icon: '#F87171',
    alert_red_title: '#FCA5A5',
    alert_orange_bg: '#2D1A00',
    alert_orange_border: '#78350F',
    alert_orange_icon: '#FB923C',
    alert_orange_title: '#FDBA74',
    alert_blue_bg: '#0F1F3A',
    alert_blue_border: '#1E3A5F',
    alert_blue_icon: '#60A5FA',
    alert_blue_title: '#93C5FD',
    alert_green_bg: '#142E1D',
    alert_green_border: '#14532D',
    alert_green_icon: '#4ADE80',
    alert_green_title: '#86EFAC',
    success_bg: '#2e4d28',
    error_bg: '#5C2A2E',
    error_icon: '#E83F5B',
    attention_opacity: 'rgba(232, 63, 91, 0.18)',
    gold_opacity: 'rgba(253, 187, 97, 0.22)',

    /* ─── Home services grid ─── */
    home_service_fuel_bg: '#2C2C2E',
    home_service_fuel_icon_bg: '#1a1a1a',
    home_service_fines_bg: '#2C2C2E',
    home_service_fines_icon_bg: '#1a1a1a',
    home_service_loan_bg: '#2C2C2E',
    home_service_loan_icon_bg: '#1a1a1a',
    home_service_others_bg: '#2C2C2E',
    home_service_others_icon_bg: '#1a1a1a',
  },

  fonts: {
    light: 'Poppins-Light',
    regular: 'Poppins-Regular',
    medium: 'Poppins-Medium',
    semibold: 'Poppins-SemiBold',
    bold: 'Poppins-Bold',
    fuel: 'OpenSans-ExtraBoldItalic',
  },

  mapstyle: [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#212121',
        },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#212121',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e',
        },
      ],
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bdbdbd',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#181818',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#1b1b1b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#2c2c2c',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8a8a8a',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#373737',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#3c3c3c',
        },
      ],
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry',
      stylers: [
        {
          color: '#4e4e4e',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#000000',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#3d3d3d',
        },
      ],
    },
  ],
};
